import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.625 4.2168C7.625 3.11223 8.52043 2.2168 9.625 2.2168H15.625C16.7296 2.2168 17.625 3.11223 17.625 4.2168V5.2168H22.625V7.2168H2.625V5.2168H7.625V4.2168ZM9.625 5.2168H15.625V4.2168H9.625V5.2168Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.73057 8.66401L5.51943 7.76958L6.41385 9.55844C6.55271 9.83615 6.625 10.1424 6.625 10.4529V20.2168H18.625V10.4529C18.625 10.1424 18.6973 9.83615 18.8361 9.55844L19.7306 7.76958L21.5194 8.66401L20.625 10.4529V20.2168C20.625 21.3214 19.7296 22.2168 18.625 22.2168H6.625C5.52043 22.2168 4.625 21.3214 4.625 20.2168V10.4529L3.73057 8.66401Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.625 10.2168V18.2168H15.625V10.2168H13.625Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.625 18.2168V10.2168H11.625V18.2168H9.625Z",
			fill: "#395566"
		})
	]
});
export default SvgLine;
